export const buildFilter = (fields: string[], op: string = 'or') => (
    value: string
  ): string => {
    const res = fields
      .map((field: string) => `(${field}=='*${value}*')`)
      .join(` ${op} `);
    return `(${res})`;
  };
